export const canvas = {
    'canvas.dropHint': 'Drop file here',
    'zoom.in': 'Zoom in',
    'zoom.out': 'Zoom out',
    'zoom.reset': 'Reset to 100 %',
    'zoom.fit': 'Fit',
    'zoom.fitTitle': 'Fit everything (key 0)',
    'frame.fill': 'Fill',
    'frame.fillColor': 'Fill colour',
    'frame.border': 'Border',
    'frame.borderWidth': 'Border width',
    'frame.borderColor': 'Border colour',
    'frame.without': 'none',
    'frame.grid': 'Grid',
    'frame.gridTitle': 'What media snap to inside this frame',
    'frame.paddingTitle': 'Inner margin that content snaps to',
    'frame.paddingAuto': 'Margin automatic ({percent} %)',
    'frame.paddingNone': 'No margin',
    'frame.paddingShare': 'Margin {percent} %',
    'frame.auto': 'automatic ({value})',
    'frame.columnsTitle': 'Columns inside the margins',
    'frame.columns': '{count} columns',
    'frame.noColumns': 'no columns',
    'frame.rowsTitle': 'Rows inside the margins',
    'frame.rows': '{count} rows',
    'frame.noRows': 'no rows',
    'frame.scaleContent': 'Content too',
    'frame.scaleOnTitle': 'Resizing takes the content along — the aspect ratio of the frame locks while doing so. Click for free dragging.',
    'frame.scaleOffTitle': 'Resizing only changes the frame. Click to make the content grow with it.',
    'frame.saveTemplate': 'As template',
    'frame.saveTemplateTitle': 'Save this frame including its content as a template',
    'frame.dragTitle': 'Drag to move',
    'frame.labelTitle': 'Drag to move · double-click zooms to this frame',
    'text.placeholder': 'Enter text …',
    'text.size': 'Font size',
    'text.sizeSmaller': 'Smaller',
    'text.sizeLarger': 'Larger',
    'text.font': 'Font',
    'text.fontBoard': 'Fonts of this board',
    'text.fontHeading': 'Heading',
    'text.fontBody': 'Body text',
    'text.lineHeight': 'Line spacing',
    'text.lineHeightTitle': 'Line spacing — a multiple of the font size',
    'text.scaleFontOnTitle': 'Dragging a corner scales the font too. Click to resize the box only.',
    'text.scaleFontOffTitle': 'Dragging a corner resizes the box only. Click to scale the font too.',
    'text.scaleFont': 'Font too',
    'text.italic': 'Italic',
    'text.underline': 'Underline',
    'text.list': 'Bulleted list',
    'text.bold': 'Bold',
    'text.color': 'Text colour',
    'text.align.left': 'Align left',
    'text.align.center': 'Centre',
    'text.heightAutoTitle': 'Height grows with the text — click for a fixed height',
    'text.heightFixedTitle': 'Fixed height — click to let it grow again',
    'text.valign.top': 'Top of the box',
    'text.valign.middle': 'Middle of the box',
    'text.valign.bottom': 'Bottom of the box',
    'text.align.right': 'Align right',
    'iframe.width': 'Width',
    'iframe.custom': 'Custom',
    'iframe.height': 'Height',
    'iframe.heightTitle': 'How much of the page is available for scrolling',
    'iframe.windows': '{factor}× window',
    'iframe.clickInside': 'Click inside the page',
    'iframe.shieldTitle': 'Scrolling moves the page for everyone · double-click to click inside',
    'iframe.release': 'Stop controlling · Esc',
    'iframe.blocked': 'This page does not allow embedding.',
    'iframe.openTab': 'Open in a new tab',
    'present.previous': 'Previous frame',
    'present.next': 'Next frame',
    'present.noFrames': 'No frames created yet',
    'present.free': 'Free',
    'present.fixed': 'Fixed',
    'present.lockTitle': 'Fix the view again — then only changing frames moves the image',
    'present.unlockTitle': 'Allow free movement — zooming and dragging then also affects the guests',
    'present.pointer': 'Pointer',
    'present.pointerOnTitle': 'Show pointer (Z) — your mouse pointer becomes a glowing dot for everyone',
    'present.pointerOffTitle': 'Hide pointer (Z) — your pointer position is then no longer transmitted',
    'present.pointerColorTitle': 'Pointer in this colour',
    'present.pointerColorLabel': 'Pointer colour {color}',
    'present.followersTitle': 'Number of participants following your view',
    'present.nobodyConnected': 'Nobody connected',
    'present.following': '{followers} of {viewers} following',
    'present.stop': 'Stop',
    'present.someone': 'Someone',
    'present.isPresenting': '{name} is presenting',
    'present.lookingAround': 'You are looking around freely',
    'present.followAgain': 'Follow the view again',
    'notes.title': 'Notes',
    'notes.clockTitle': 'Since the start of the talk',
    'notes.empty': 'Nothing is saved for this frame. You write notes before the talk, in the frame list.',
    'notes.next': 'Up next',
    'notes.last': 'Last frame',
    'preview.title': 'Guest preview',
    'preview.empty': 'Nobody connected via the guest link yet.',
    'preview.previous': 'Previous guest',
    'preview.next': 'Next guest',
    'waiting.notStarted': 'The presentation has not started yet. This page changes by itself as soon as it begins — you do not have to do anything.',
    'waiting.changesItself': 'This page changes by itself as soon as it begins — you do not have to do anything.',
    'waiting.lockedNote': 'In this sharing mode your view follows the presenter throughout.',
    'waiting.byDigitalwart': 'by Digitalwart',
    'upload.allowed': 'images (JPEG, PNG, WebP, AVIF, GIF, TIFF, SVG), videos (MP4, WebM, MOV) and PDF',
    'upload.heic': '“{name}”: HEIC images from the iPhone are not supported. In the iPhone settings under “Camera → Formats”, switch to “Most Compatible”, or export the image as JPEG.',
    'upload.unsupported': '“{name}” is not a file type Præsto can store. Possible are {allowed}.',
    'upload.tooLarge': '“{name}” is too large ({size}, allowed is {limit}).',
};
//# sourceMappingURL=canvas.js.map